import { Cache } from '@libs/utils';
import type {
  StaticInfoResponse,
  StaticInfoType,
  HotelConstraintQL,
  PortStaticInfo,
  CarrierName,
  CarrierStaticInfo,
} from '@libs/trip-planner-interfaces';

// TODO: Look into Memoizee to replace Cache
// https://medium.com/angular-in-depth/how-to-improve-angular-performance-by-just-adding-just-8-characters-877bde708ddd
const hotelsCacheSize = 300;
const carriersCacheSize = 100;
const transportsCacheSize = 20;

export const carriersCache = new Cache<CarrierStaticInfo>(carriersCacheSize);
export const carriersNameCache = new Cache<CarrierName>(carriersCacheSize);
export const airportsCache = new Cache<PortStaticInfo>(transportsCacheSize);
export const seaportsCache = new Cache<PortStaticInfo>(transportsCacheSize);
export const hotelsCache = new Cache<StaticInfoResponse<StaticInfoType>>(
  hotelsCacheSize
);

export function createCacheKey(
  constraint: HotelConstraintQL,
  type?: StaticInfoType
): string {
  return JSON.stringify({
    constraint,
    type,
  });
}
